import { render, staticRenderFns } from "./TeamLink.vue?vue&type=template&id=5e893ca7"
import script from "./TeamLink.vue?vue&type=script&lang=js"
export * from "./TeamLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e893ca7')) {
      api.createRecord('5e893ca7', component.options)
    } else {
      api.reload('5e893ca7', component.options)
    }
    module.hot.accept("./TeamLink.vue?vue&type=template&id=5e893ca7", function () {
      api.rerender('5e893ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamLink.vue"
export default component.exports